const ListView = () => {
  return <div>This is list view</div>;
};

export default ListView;
